import * as types from '../mutation-types'
import imagesRepository from '../../api/imagesRepository'

const state = {
  imageLocation: []
}

const getters = {
  imageLocation: state => state.imageLocation,
  brandImage: state => state.brandImage
}

const actions = {
  uploadImage ({commit}, image) {
    return imagesRepository.uploadImage(image).then((response) => {
      commit(types.SET_IMAGE_LOCATION, response.data)
    })
  }
}

const mutations = {
  [types.SET_IMAGE_LOCATION] (state, payload) {
    state.imageLocation = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
